import { FC } from 'react';
import { Heading, Text, Icon } from '@livechat/design-system-react-components';

import { Product } from 'types/product';
import { getProductDisplayName, getProductName } from 'helpers/product';
import { getLogoSource } from 'helpers/logo';

import {
  labelStyles,
  productItemStyles,
  productTextContainerStyles,
  headingStyles,
} from './styles';

type Props = {
  product: Product;
  label: string;
  url: string;
};

export const ProductListItem: FC<Props> = ({ url, product, label }) => {
  const productName = getProductName(product);

  return (
    <a
      href={url}
      css={productItemStyles}
      data-testid="product-list-item"
      target="_blank"
      rel="noreferrer"
    >
      <Icon source={getLogoSource(productName)} />
      <div css={productTextContainerStyles}>
        <Heading css={headingStyles} size="xs">
          {getProductDisplayName(productName)}
        </Heading>
        <Text css={labelStyles}>{label}</Text>
      </div>
    </a>
  );
};
